import { CardTransactionDetail, cryptoRandomUUID } from '@finxone-platform/shared/sys-config-types';

const labelTextSkeleton = (widthClass: string) => `
<span class="labelText skeleton_item ${widthClass}">
  <span class="skeleton_item"></span>
</span>
`;

export const currentCardTransactionDetailSkeleton: CardTransactionDetail = {
  id: cryptoRandomUUID().toString(),
  description: labelTextSkeleton('skeleton_50'),
  type: labelTextSkeleton('skeleton_25'),
  transactionInfo: {
    totalAmount: labelTextSkeleton('skeleton_50'),
    amount: labelTextSkeleton('skeleton_50'),
    currency: labelTextSkeleton('skeleton_75'),
    originalAmount: labelTextSkeleton('skeleton_50'),
    originalAmountCurrency: labelTextSkeleton('skeleton_25'),
  },
  merchantInfo: {
    id: cryptoRandomUUID().toString(),
    name: labelTextSkeleton('skeleton_75'),
    city: labelTextSkeleton('skeleton_50'),
    country: labelTextSkeleton('skeleton_50'),
    streetNumber: labelTextSkeleton('skeleton_25'),
    address: labelTextSkeleton('skeleton_50'),
    postalCode: labelTextSkeleton('skeleton_75'),
    image: labelTextSkeleton('skeleton_50'),
    phone: labelTextSkeleton('skeleton_25'),
  },
  date: labelTextSkeleton('skeleton_100'),
  status: labelTextSkeleton('skeleton_100'),
  feeInfo: {
    feeAmount: labelTextSkeleton('skeleton_25'),
    feeCurrency: labelTextSkeleton('skeleton_50'),
    ecbMarkup: labelTextSkeleton('skeleton_75'),
    atmFeeAmount: labelTextSkeleton('skeleton_50'),
    atmFeeCurrency: labelTextSkeleton('skeleton_25'),
    exchangeRate: labelTextSkeleton('skeleton_100'),
    exchangeRateCurrency: labelTextSkeleton(''),
  },
};
